import { Box, SvgIconTypeMap, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import React, { FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { useStyles } from './GameMenuItem.styles';
import { StartMenuItemIcon } from 'app/components/Sidebar/StartMenuItemIcon';
import { useLocation } from 'react-router-dom';
import { EditGameButton } from 'app/components/Sidebar/GameMenu/EditGameButton';
import { GameNavigationMenuItem } from 'app/interfaces/sidebar/game-navigation-menu-item';
import { EndMenuItemIcon } from 'app/components/Sidebar/EndMenuItemIcon';

interface NavigationItemProps {
  item: GameNavigationMenuItem;
  startIcon?: string | OverridableComponent<SvgIconTypeMap>;
  endIcon?: string | OverridableComponent<SvgIconTypeMap>;
  onClick?: (item: GameNavigationMenuItem) => void;
  onEdit?: (item: GameNavigationMenuItem) => void;
  className?: string;
  height?: number;
}

export const GameMenuItem: FC<NavigationItemProps> = ({
  item,
  startIcon,
  endIcon,
  className,
  onClick,
  onEdit,
  height = 0,
}) => {
  const { classes } = useStyles({ height });
  const { pathname } = useLocation();

  const isActive = useMemo(() => pathname === item?.route, [pathname, item?.route]);

  const onClickHandler = useCallback(() => {
    if (item?.disabled) {
      return;
    }

    onClick?.(item);
  }, [onClick, item]);

  const onEditClickHandler = useCallback(() => onEdit?.(item), [item, onEdit]);

  if (!item) {
    return null;
  }

  return (
    <Box
      onClick={onClickHandler}
      className={classNames(className, classes.root, { [classes.activeContainer]: isActive })}
    >
      <Box className={classes.menuItem}>
        {startIcon && <StartMenuItemIcon icon={startIcon} isActive={isActive} />}
        <Typography className={classNames(classes.label, { [classes.disabled]: item?.disabled })}>
          {item.label}
        </Typography>
        {endIcon && <EndMenuItemIcon icon={endIcon} />}
        {item?.editable && (
          <Box className="edit-button-container">
            <EditGameButton onClick={onEditClickHandler} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
